<template>
  <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>Category</strong> Form
          </div>
          <b-form v-on:submit.prevent="saveForm()">
            <b-form-group
              label="Name"
              label-for="horizEmail"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="horizEmail" type="text"  autocomplete="Name" required class="form-control-warning" v-model="user.name"></b-form-input>              
            </b-form-group>
            <div class="b-form-group form-group form-row">
                  <label id="" for="category" class="col-sm-3 col-form-label col-form-label-sm " >Parent</label>
                  <div class="col-md-4">
                    <select  class="form-control form-control-sm custom-select custom-select-sm" v-model="user.parent" required >
                      <option v-for="item in parent" :key="item.id" :value="item.id">{{item.name}}</option>
                    </select>
                  </div>
            </div>
            <!--
            <b-form-group
              label="Photo"
              label-for="photo"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-file id="photo" ref="file" placeholder="Enter photo.." autocomplete="photo" class="form-control-warning" @change="onFileChange" accept="image/*"></b-form-file>              
            </b-form-group>
            <div class="form-group">
              <div class="form-row">
                <label id="__BVID__244__BV_label_" for="password" class="col-sm-3 col-form-label"></label>
                <div class="col-sm-9">              
                  <b-progress :value="uploadPercentage" :max="100" show-progress animated  v-if="!image"></b-progress>
                  <img :src="image" class="" style="width:100px"  v-if="image" />
                </div>
              </div>
            </div>
            -->
            <div slot="footer">
              <div class="form-row">
                <div class="col-sm-3">
                  
                </div>
                <div class="col-sm-9">
                  <b-button type="submit" size="sm" variant="primary" :disabled="isLoading" > Submit</b-button>
                  <b-button type="button" @click="goBack" size="sm" variant="danger" :disabled="isLoading">Back</b-button>
                </div>
              </div>

            </div>
          </b-form>
        </b-card>
      </b-col>
      
      <BlockUI message="loading" v-if="isLoading">
        <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
      </BlockUI>
  </b-row>
</template>

<script>
//import categoriesData from './categoriesData'
import { VueEditor } from 'vue2-editor'
export default {
  name: 'Category',
  components: {
      VueEditor
   },
  props: {
    caption: {
      type: String,
      default: 'Category '
    },
  },
  
  mounted() {
    this.id = this.$route.params.id;
    this.getParent();
    if(this.id !== undefined){
      this.getData(this.id);
    }
  },
  data: () => {
    return {
      error: false,
      user: {
        email: '',
      },
      parent:[],
      image:'',
      file:'',
      uploadPercentage :0,
      msg : '',
      id:'',
      msg_type : '',
      isLoading:false,
    }
    
  },
  methods: {
    getParent(){
      var app = this;
      var url = this.end_point+'categories_parent';
      app.isLoading = true;
      axios.get(url, {})
        .then(function (resp) {
        app.isLoading=false;
        if(resp.data.error){
          app.$notify.error(resp.data.msg);
        }else{
          app.parent = resp.data.data;
        }
      })
      .catch(function (resp) {
        console.log(resp);
        app.isLoading=false;
        // app.$notify.error(app.setting.msg_con);
        app.error = true;
      });
    },  
    getData(id){
      var app = this;
      var url = this.end_point+'categories/'+id;
      app.isLoading = true;
      axios.get(url, {})
        .then(function (resp) {
        app.isLoading=false;
        if(resp.data.error){
          app.$notify.error(resp.data.msg);
        }else{
          app.user = resp.data.data;
          if(resp.data.data.prev_img){
            //alert(resp.data.row.prev_img);
            app.image = resp.data.data.prev_img;
          }
        }
      })
      .catch(function (resp) {
        console.log(resp);
        app.isLoading=false;
        // app.$notify.error(app.setting.msg_con);
        app.error = true;
      });  
    },
    saveForm() {
      var app = this;
      var newDt = app.user;
      var url = this.end_point;

      var api = '';
      if(this.id === undefined){
        url += 'categories';
        api = axios.post(url, newDt);
      }else{
        url += 'categories/'+this.id;
        api = axios.put(url, newDt);
      }
      app.isLoading=true;
      api
      .then(function (resp) {
        app.isLoading=false;
        if(resp.data.error){
          app.$notify.error(resp.data.msg);
          window.scrollTo(0,0);
        }else{
          app.$notify.success(resp.data.msg);
          app.$router.replace(`/category`);
        }
      })
      .catch(function (resp) {
        app.isLoading=false;
        app.$notify.error(app.setting.msg_con);
      });
    },
    goBack() {
      this.$router.go(-1)
    },
    submitFile(){
      let formData = new FormData();
      formData.append('file', this.file);
      var app  = this;
      app.isLoading=true;
      axios.post( this.end_point+'categories/upload',formData,{
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: function( progressEvent ) {
          this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
        }.bind(this)
      }).then(function(e){
        
        app.isLoading=false;
        //console.log(e);
        if(e.data.error){
          app.msg = e.data.msg;
          app.msg_type = 'danger';
          return false;
        }
        app.msg='';
        app.user.new_file = e.data.file_path;       
        app.createImage(app.file);
      })
      .catch(function(e){
          app.isLoading=false;
          app.msg = 'upload filed please try again';
          app.msg_type = 'danger';
      });
    },
    onFileChange(e){
      this.image= '';
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length){      
          return;
      }
      this.file = files[0];
      this.submitFile();
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
  }
}
</script>
